import React from "react";
import { Form, Input, Radio, Select, Slider } from "antd";
const { TextArea } = Input;
const { Option } = Select;
export function FormComponent({
  formItemLayout,
  getFieldDecorator,
  input,
  option,
  showOther,
  onSearch,
  technicalSkills,
  itemData
}) {
  // 
  const isEdit = itemData !== null;
  return (
    <Form {...formItemLayout}>
      <Form.Item label="Project Name" className="formsteponeinout">
        {getFieldDecorator("projectName", {
          initialValue: itemData ? itemData.projectName : undefined,
          rules: [
            {
              required: true,
              message: "Please enter your project name"
            }
          ]
        })(
          <Input
            placeholder="Enter your Project Name"
            type="text"
            disabled={isEdit}
          />
        )}
      </Form.Item>

      <Form.Item label="Project Description" className="formsteponeinout">
        {getFieldDecorator("projectDescription", {
          initialValue: itemData ? itemData.projectDescription : undefined,
          rules: [
            {
              required: true,
              message: "Please enter your project description"
            }
          ]
        })(
          <TextArea
            placeholder="Please enter your project description"
            autosize
          />
        )}
      </Form.Item>

      <Form.Item className="formsteponeinout" label="Project Completion Level">
        {getFieldDecorator("projectCompletionLevel", {
          initialValue: itemData ? itemData.projectCompletionLevel : 0,
          rules: [
            {
              required: true,
              message: "Select your project completion level"
            }
          ]
        })(
          <Slider
            marks={{
              0: "10%",
              20: "20%",
              40: "40%",
              60: "60%",
              80: "80%",
              100: "100%"
            }}
          />
        )}
      </Form.Item>

      <Form.Item
        className="formsteponeinout"
        label="Select technologies used in project"
      >
        {getFieldDecorator("projectTechnologiesUsed", {
          initialValue: itemData ? itemData.projectTechnologiesUsed : [],
          rules: [
            {
              required: true,
              message: "List down technologies used in project"
            }
          ]
        })(
          <Select
            mode="tags"
            style={{ width: "100%" }}
            placeholder="Search or Add new technologies"
          >
            {children}
          </Select>
        )}
      </Form.Item>

      <Form.Item
        label="Are you working Alone or as a Team on this project?"
        className="formsteponeinout"
      >
        {getFieldDecorator("projectTeam", {
          initialValue: itemData ? itemData.projectTeam : undefined,
          rules: [
            {
              required: true,
              message: "Please select the answer"
            }
          ]
        })(
          <Radio.Group>
            <Radio value="Alone">Alone</Radio>
            <Radio value="Team">Team</Radio>
          </Radio.Group>
        )}
      </Form.Item>

      <Form.Item
        label="Do you need any assistance in improving/finishing this project?"
        className="formsteponeinout"
      >
        {getFieldDecorator("projectImprovingAssistance", {
          initialValue: itemData
            ? itemData.projectImprovingAssistance
            : undefined,
          rules: [
            {
              required: true,
              message: "Please select the answer"
            }
          ]
        })(
          <Radio.Group>
            <Radio value="yes">YES</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
        )}
      </Form.Item>
    </Form>
  );
}
const children = [
  <Option key={"C"} value="C">
    C
  </Option>,
  <Option key={"C++"} value="C++">
    C++
  </Option>,
  <Option key={"C#"} value="C#">
    C#
  </Option>,
  <Option key={"Java"} value="Java">
    Java
  </Option>,
  <Option key={"Python"} value="Python">
    Python
  </Option>,
  <Option key={"Javascript"} value="Javascript">
    JavaScript
  </Option>,
  <Option key={"PHP"} value="PHP">
    PHP
  </Option>,
  <Option key={"Swift"} value="Swift">
    Swift
  </Option>,
  <Option key={"Ruby"} value="Ruby">
    Ruby
  </Option>,
  <Option key={"R"} value="R">
    R-Programming
  </Option>,
  <Option key={"VLSI"} value="VLSI">
    VLSI
  </Option>,
  <Option key={"Html"} value="Html">
    HTML
  </Option>,
  <Option key={"CSS"} value="CSS">
    CSS
  </Option>,
  <Option key={"Bootstrap"} value="Bootstrap">
    Bootstrap
  </Option>,
  <Option key={"React"} value="React">
    React
  </Option>,
  <Option key={"AngularJS"} value="AngularJS">
    Angular JS
  </Option>,
  <Option key={"VueJS"} value="VueJS">
    VueJS
  </Option>,
  <Option key={"NodeJS"} value="NodeJS">
    NodeJS
  </Option>,
  <Option key={"Android"} value="Android">
    Android Development
  </Option>,
  <Option key={"IOS"} value="IOS">
    IOS Development
  </Option>,
  <Option key={"HTML"} value="HTML">
    Blockchain
  </Option>,
  <Option key={"ML"} value="ML">
    Machine Learning
  </Option>,
  <Option key={"AI"} value="AI">
    Artificial Intelligence
  </Option>,
  <Option key={"IoT"} value="IoT">
    Internet Of Things
  </Option>,
  <Option key={"Robotics"} value="Robotics">
    Robotics
  </Option>,
  <Option key={"SQL"} value="SQL">
    SQL
  </Option>,
  <Option key={"NoSQL"} value="NoSQL">
    NoSQL
  </Option>,
  <Option key={"CAD"} value="CAD">
    Auto CAD
  </Option>
];
